import { api } from "arctic-vuejs-template";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const generateAutoURL = state => {
  let path = "";
  if (state.content.navigationItem.text) {
    path =
      state.content.navigationItem.text
        .replace(/\W+/g, "-")
        .replace(/-$/g, "")
        .toLowerCase() + "/";
  }
  if (state.content.title) {
    path += state.content.title
      .replace(/\W+/g, "-")
      .replace(/-$/g, "")
      .toLowerCase();
  }
  return path;
};

export default new Vuex.Store({
  state: {
    content: {
      id: null,
      title: null,
      body: null,
      hero: {
        enabled: null,
        image: null,
        body: null
      },
      navigationItem: {
        enabled: null,
        parent_id: null,
        text: null
      },
      urlAlias: {
        auto: null,
        overridden: null,
        path: null
      }
    },
    navigation: []
  },
  mutations: {
    INIT_CONTENT: state => {
      state.content.id = null;
      state.content.title = null;
      state.content.body = null;
      state.content.hero.enabled = false;
      state.content.hero.image = null;
      state.content.hero.body = null;
      state.content.navigationItem.enabled = null;
      state.content.navigationItem.parent_id = null;
      state.content.navigationItem.text = null;
      state.content.urlAlias.auto = true;
      state.content.urlAlias.overridden = null;
      state.content.urlAlias.path = null;
    },
    SET_CONTENT_ID: (state, value) => {
      state.content.id = value;
    },
    SET_CONTENT_TITLE: (state, value) => {
      state.content.title = value;
      if (state.content.urlAlias.auto) {
        state.content.urlAlias.path = generateAutoURL(state);
      }
    },
    SET_CONTENT_BODY: (state, value) => {
      state.content.body = value;
    },
    SET_CONTENT_HERO_ENABLED: (state, value) => {
      state.content.hero.enabled = value;
    },
    SET_CONTENT_HERO_IMAGE: (state, value) => {
      state.content.hero.image = value;
    },
    SET_CONTENT_HERO_BODY: (state, value) => {
      state.content.hero.body = value;
    },
    SET_CONTENT_URL_ALIAS_AUTO: (state, value) => {
      state.content.urlAlias.auto = value;
      if (value) {
        state.content.urlAlias.overridden = state.content.urlAlias.path;
        state.content.urlAlias.path = generateAutoURL(state);
      } else {
        state.content.urlAlias.path = state.content.urlAlias.overridden;
      }
    },
    SET_CONTENT_NAVIGATION_ITEM_ENABLED: (state, value) => {
      state.content.navigationItem.enabled = value;
    },
    SET_CONTENT_NAVIGATION_ITEM_PARENT: (state, value) => {
      state.content.navigationItem.parent_id = value;
    },
    SET_CONTENT_NAVIGATION_ITEM_TEXT: (state, value) => {
      state.content.navigationItem.text = value;
    },
    SET_CONTENT_NAVIGATION_ITEM_ICON: (state, value) => {
      state.content.navigationItem.icon = value;
    },
    SET_CONTENT_URL_ALIAS_PATH: (state, value) => {
      state.content.urlAlias.path = value
        .replace(/[^\w\d/]+/g, "-")
        .toLowerCase();
    },
    SET_NAVIGATION: (state, value) => {
      state.navigation = value;
    }
  },
  actions: {
    INIT_CONTENT({ commit, dispatch }) {
      dispatch("LOAD_NAVIGATION");
      commit("INIT_CONTENT");
    },
    LOAD_CONTENT({ commit, dispatch }, id) {
      dispatch("LOAD_NAVIGATION");
      return api.get(`/content/${id}`).then(response => {
        commit("SET_CONTENT_ID", id);
        commit("SET_CONTENT_TITLE", response.data.current_revision.title);
        commit("SET_CONTENT_BODY", response.data.current_revision.data.body);
        if (response.data.current_revision.data.hero && response.data.current_revision.data.hero.image) {
          commit("SET_CONTENT_HERO_ENABLED", true);
          commit("SET_CONTENT_HERO_IMAGE", response.data.current_revision.data.hero.image);
          commit("SET_CONTENT_HERO_BODY", response.data.current_revision.data.hero.body);
        }
        if (response.data.navigationItem) {
          commit("SET_CONTENT_NAVIGATION_ITEM_ENABLED", true);
          commit(
            "SET_CONTENT_NAVIGATION_ITEM_PARENT",
            response.data.navigationItem.parent_id
          );
          commit(
            "SET_CONTENT_NAVIGATION_ITEM_TEXT",
            response.data.navigationItem.text
          );
          commit(
            "SET_CONTENT_NAVIGATION_ITEM_ICON",
            response.data.navigationItem.icon
          );
        }
        commit("SET_CONTENT_URL_ALIAS_PATH", response.data.urlAlias.path);
      });
    },
    LOAD_NAVIGATION({ commit }) {
      api.get("/navigation").then(response => {
        const navigation = {};
        Object.keys(response.data).forEach(key => {
          navigation[response.data[key].id] = response.data[key].text;
        });
        commit("SET_NAVIGATION", navigation);
      });
    },
    DELETE_CONTENT({ state }) {
      return api.delete(`/content/${state.content.id}`);
    },
    SAVE_CONTENT({ state }) {
      if (state.content.id) {
        return api.patch(`/content/${state.content.id}`, state.content);
      } else {
        return api.post("/content", state.content);
      }
    }
  }
});
